import type { JSX } from 'react';

import './HoverTooltip.scss';

export interface HoverTooltipProps {
  tooltipText: string;
  children?: JSX.Element;
}

export const HoverTooltip = ({ tooltipText, children }: HoverTooltipProps) => {
  return (
    <div className="hovertooltip">
      <span className="tooltiptext ea-disclaimertext">{tooltipText}</span>
      {children}
    </div>
  );
};
